import z from 'zod'
import { decimalSchema } from '../../utils/schema'

// 基本トランザクションスキーマ
const baseTransactionSchema = z.object({
  /** アセットID */
  assetId: z.number(),
  /** チェーン名 */
  chain: z.string().nullish(),
  /** 推定完了時刻（Unix秒） */
  etaTsSec: z.number().nullish(),
  /** トランザクションID */
  id: z.number(),
  /** 数量 */
  quantity: decimalSchema,
  /** ステータス */
  status: z.string(),
  /** タイムスタンプ（Unix秒） */
  timestampSec: z.number(),
  /** トークン名 */
  token: z.string().nullish(),
  /** トランザクションタイプ */
  transactionType: z.enum([
    'deposit',
    'withdrawal',
    'transfer-in',
    'transfer-out',
  ]),
})

// Deposit 固有フィールド
const depositSchema = baseTransactionSchema.extend({
  transactionType: z.literal('deposit'),
  /** ブロック番号 */
  blockNumber: z.number().optional(),
  /** トランザクションハッシュ */
  transactionHash: z.string().optional(),
})

// Withdrawal 固有フィールド
const withdrawalSchema = baseTransactionSchema.extend({
  transactionType: z.literal('withdrawal'),
  /** 出金先アドレス */
  withdrawalAddress: z.string().optional(),
})

// Transfer-in 固有フィールド
const transferInSchema = baseTransactionSchema.extend({
  transactionType: z.literal('transfer-in'),
  /** 送金元アカウントID */
  srcAccountId: z.number().optional(),
  /** 送金元アドレス */
  srcAddress: z.string().optional(),
})

// Transfer-out 固有フィールド
const transferOutSchema = baseTransactionSchema.extend({
  transactionType: z.literal('transfer-out'),
  /** 受取先アカウントID */
  receivingAccountId: z.number().optional(),
  /** 受取先アドレス */
  receivingAddress: z.string().optional(),
})

// 統合トランザクションスキーマ
export const transactionSchema = z.union([
  depositSchema,
  withdrawalSchema,
  transferInSchema,
  transferOutSchema,
])

export const capitalHistoryResponseSchema = z.object({
  transactions: z.array(transactionSchema),
})

export type Transaction = z.infer<typeof transactionSchema>
export type CapitalHistoryResponse = z.infer<
  typeof capitalHistoryResponseSchema
>
